/**
 * Runtime AI model availability types.
 *
 * These mirror the backend /api/ai/models response and intentionally expose
 * metadata only. API key values never leave the backend.
 */

import type { AIProviderType } from './aiKey.types';

export type AIKeySource = 'user' | 'admin' | 'platform';

export interface AvailableAITextModel {
  id: string;
  provider: AIProviderType;
  displayName: string;
  maxInputTokens: number;
  maxOutputTokens: number;
  costPer1kInput: number;
  costPer1kOutput: number;
  supportsStructuredOutput: boolean;
  supportsStreaming: boolean;
  supportsVision?: boolean;
}

export interface AvailableAIImageModel {
  id: string;
  provider: AIProviderType;
  displayName: string;
  supportsReferenceImages: boolean;
  maxReferenceImages: number;
}

export interface ProviderModelAvailability {
  configured: boolean;
  source?: AIKeySource;
  textModels: boolean;
  imageModels: boolean;
}

export interface AvailableAIModels {
  textModels: AvailableAITextModel[];
  imageModels: AvailableAIImageModel[];
  providers: Partial<Record<AIProviderType, ProviderModelAvailability>>;
}

export const EMPTY_AVAILABLE_AI_MODELS: AvailableAIModels = {
  textModels: [],
  imageModels: [],
  providers: {},
};
